module.exports = __webpack_public_path__ + "img/jsLogo.0cded3a3.png";